module.exports = __webpack_public_path__ + "images/ea364e82475a81953e238bdc6db42039.svg";